import { Grid, useEventCallback } from '@mui/material';
import Buttons from 'front-office/components/certification-form/buttons';
import { Form, Formik } from 'formik';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { useNavigate } from 'react-router-dom';
import {
  CertificateValueBorn,
  CertificateValueCitizenship,
  CertificateValueCivilUnion,
  CertificateValueDeath,
  CertificateValueMarriage,
  CertificationFormVM,
} from 'front-office/view-models/document-birth-form';
import FormDetail from 'front-office/components/certification-form';
import { useMemo, useState } from 'react';
import { ObjectShape } from 'yup/lib/object';
import * as yup from 'yup';
import {
  // fiscalCodeRegex,
  regexOnlyStringNumericWithSpecialCharacters,
} from 'shell/constants/regex';
import { useUserProfile } from 'shell/hooks/use-user-profile';
import { SelectOperatorChoice } from 'shell/constants/select-choice-operator';
import { CommonFrontOfficeCrumbs } from 'front-office/constants/breadcrumb';
import initialValues from './initial-values';

const createSchema = (active: number) => {
  let schemaObject: ObjectShape = {};

  if (active === 0) {
    schemaObject = {
      flagInternal: yup.boolean(),
      reasonRelease: yup.string().when('flagInternal', {
        is: true,
        then: yup.string().required('Il campo è obbligatorio'),
        otherwise: yup.string(),
      }),
      searchApplicant: yup.boolean().when('flagInternal', {
        is: false || undefined,
        then: yup.boolean().required('Effettuare almeno una ricerca'),
        otherwise: yup.boolean(),
      }),
      fiscalCode: yup.string().when('flagInternal', {
        is: false || undefined,
        then: yup.string().required('Il campo è obbligatorio'),
        otherwise: yup.string(),
      }),
      // .matches(fiscalCodeRegex, 'Il campo deve essere un codice fiscale'),
      surname: yup
        .string()
        .matches(regexOnlyStringNumericWithSpecialCharacters, 'Campo non valido')
        .when(['withoutSurname', 'flagInternal'], {
          is: (withoutSurname: boolean, flagInternal: boolean) => {
            if (withoutSurname || flagInternal) {
              return true;
            }
            return false;
          },
          then: yup.string().nullable().notRequired(),
          otherwise: yup.string().nullable().required('Campo obbligatorio'),
        }),
      name: yup
        .string()
        .matches(regexOnlyStringNumericWithSpecialCharacters, 'Campo non valido')
        .when(['withoutName', 'flagInternal'], {
          is: (withoutName: boolean, flagInternal: boolean) => {
            if (withoutName || flagInternal) {
              return true;
            }
            return false;
          },
          then: yup.string().nullable().notRequired(),
          otherwise: yup.string().nullable().required('Campo obbligatorio'),
        }),
      gender: yup.string().when('flagInternal', {
        is: false || undefined,
        then: yup.string().required('Il campo è obbligatorio'),
        otherwise: yup.string(),
      }),
      isForeign: yup.boolean(),
      birthDate: yup
        .date()
        .nullable()
        .when('flagInternal', {
          is: false || undefined,
          then: yup
            .date()
            .nullable()
            .required('Il campo è obbligatorio')
            .typeError('Data non valida'),
          otherwise: yup.date().nullable().typeError('Data non valida'),
        }),
      municipality: yup
        .object()
        .shape({})
        .nullable()
        .when(['isForeign', 'flagInternal'], {
          is: (isForeign: boolean, flagInternal: boolean) => {
            if (isForeign || flagInternal) {
              return true;
            }
            return false;
          },
          then: yup.object().shape({}).nullable().notRequired(),
          otherwise: yup.object().shape({}).nullable().required('Campo obbligatorio'),
        }),
      foreignState: yup
        .object()
        .shape({})
        .nullable()
        .when(['isForeign', 'flagInternal'], {
          is: (isForeign: boolean, flagInternal: boolean) => {
            if (!isForeign || !flagInternal) {
              return false;
            }
            return true;
          },
          then: yup.object().shape({}).nullable().required(),
          otherwise: yup.object().shape({}).nullable(),
        }),
      foreignMunicipality: yup
        .object()
        .shape({})
        .nullable()
        .when(['isForeign', 'flagInternal'], {
          is: (isForeign: boolean, flagInternal: boolean) => {
            if (!isForeign || !flagInternal) {
              return false;
            }
            return true;
          },
          then: yup.object().shape({}).nullable().required(),
          otherwise: yup.object().shape({}).nullable(),
        }),
      documentNumber: yup.string().when('flagInternal', {
        is: false || undefined,
        then: yup.string().required('Il campo è obbligatorio'),
        otherwise: yup.string(),
      }),
      documentIssuedDate: yup
        .date()
        .nullable()
        .when('flagInternal', {
          is: false || undefined,
          then: yup
            .date()
            .nullable()
            .required('Il campo è obbligatorio')
            .typeError('Data non valida'),
          otherwise: yup.date().nullable().typeError('Data non valida'),
        }),
      municipalityDocument: yup
        .object()
        .shape({})
        .nullable()
        .when(['isForeignDocument', 'flagInternal'], {
          is: (isForeignDocument: boolean, flagInternal: boolean) => {
            if (!isForeignDocument || !flagInternal) {
              return false;
            }
            return true;
          },
          then: yup.object().shape({}).nullable().required(),
          otherwise: yup.object().shape({}).nullable(),
        }),
    };
  }
  if (active === 1) {
    schemaObject = {
      certificate: yup.object().shape({}).nullable().required('Tipo certificato obbligatorio'),
    };
  }
  if (active === 2) {
    schemaObject = {
      chosenDocument: yup.object().nullable().required('Campo obbligatorio'),
    };
  }
  if (active === 3) {
    schemaObject = {};
  }
  if (active === 4) {
    schemaObject = {
      flagInternal: yup.boolean(),
      flagCarta: yup.boolean(),
      typePayment: yup.string().when(['flagInternal', 'flagCarta'], {
        is: (flagInternal: boolean, flagCarta: boolean) => flagInternal || flagCarta,
        then: yup.string().nullable().notRequired(),
        otherwise: yup.string().nullable().required('Campo obbligatorio'),
      }),
    };
  }
  return yup
    .object()
    .shape(schemaObject)
    .test('', '', (values) => {
      const castedValues = values as unknown as CertificationFormVM;

      if (active === 2) {
        if (
          castedValues?.documentSearch?.surnameHusband?.includes("'") &&
          castedValues.documentSearch?.operationSurnameHusband !== SelectOperatorChoice.Contains
        ) {
          return new yup.ValidationError(
            'Per le stringhe che contengono l\'apostrofo ripetere la ricerca specificando la parte prima o dopo l\'apostrofo e il criterio "Contiene".',
            undefined,
            'documentSearch.surnameHusband'
          );
        }

        if (
          castedValues.documentSearch?.nameHusband?.includes("'") &&
          castedValues.documentSearch?.operationNameHusband !== SelectOperatorChoice.Contains
        ) {
          return new yup.ValidationError(
            'Per le stringhe che contengono l\'apostrofo ripetere la ricerca specificando la parte prima o dopo l\'apostrofo e il criterio "Contiene".',
            undefined,
            'documentSearch.nameHusband'
          );
        }

        if (
          castedValues.documentSearch?.surnameWife?.includes("'") &&
          castedValues.documentSearch?.operationSurnameWife !== SelectOperatorChoice.Contains
        ) {
          return new yup.ValidationError(
            'Per le stringhe che contengono l\'apostrofo ripetere la ricerca specificando la parte prima o dopo l\'apostrofo e il criterio "Contiene".',
            undefined,
            'documentSearch.surnameWife'
          );
        }

        if (
          castedValues.documentSearch?.nameWife?.includes("'") &&
          castedValues.documentSearch?.operationNameWife !== SelectOperatorChoice.Contains
        ) {
          return new yup.ValidationError(
            'Per le stringhe che contengono l\'apostrofo ripetere la ricerca specificando la parte prima o dopo l\'apostrofo e il criterio "Contiene".',
            undefined,
            'documentSearch.nameWife'
          );
        }
      }

      if (active !== 4) {
        return true;
      }

      const isCopia =
        castedValues.certificate?.value === CertificateValueBorn.copia ||
        castedValues.certificate?.value === CertificateValueMarriage.copia ||
        castedValues.certificate?.value === CertificateValueDeath.copia ||
        castedValues.certificate?.value === CertificateValueCivilUnion.copia ||
        castedValues.certificate?.value === CertificateValueCitizenship.copia;

      if (isCopia) {
        const keys = ['timber', 'reason'] as Array<keyof CertificationFormVM>;
        const errors = keys
          .map((key) => {
            if (castedValues[key]) {
              return null;
            } // Successful validation, no error

            return new yup.ValidationError('Il campo è obbligatorio', castedValues[key], key);
          })
          .filter((item) => !!item) as unknown as Array<yup.ValidationError>;
        if (errors.length === 0) {
          return true;
        }
        return new yup.ValidationError(errors);
      }
      return true;
    });
};

export default function CertificationFormPage(): React.ReactElement {
  const navigate = useNavigate();

  const [active, setActive] = useState<number>(0);

  const { userProfile } = useUserProfile();

  const cashManagement = userProfile?.datiLogin?.profile?.servizio?.gestioneCassa || '';

  const isDisabled = cashManagement !== 'S';

  const onNext = useEventCallback(() => {
    setActive(active + 1);
  });

  const onBack = useEventCallback(() => {
    if (!active) {
      return;
    }
    setActive(active - 1);
  });

  const handleExit = useEventCallback(() => {
    navigate('/sportello');
  });

  const validationSchema = useMemo(() => {
    return createSchema(active);
  }, [active]);

  return (
    <>
      <Breadcrumbs
        items={[
          ...CommonFrontOfficeCrumbs,
          { name: 'Certificazione Stato Civile', path: '/sportello/stato-civile/certificazione' },
        ]}
        base="stato-civile"
      />
      <Formik
        initialValues={
          {
            ...initialValues,
            flagCarta: isDisabled,
            flagInternal: isDisabled,
          } as CertificationFormVM
        }
        validationSchema={validationSchema}
        onSubmit={onNext}
        validateOnMount
      >
        <Form>
          <Grid container spacing={1}>
            {active !== 3 ? (
              <Grid item xs={12} md={2}>
                <Buttons handleExit={handleExit} handleStep={setActive} activeStep={active} />
              </Grid>
            ) : undefined}

            <Grid item xs={12} md={active === 3 ? 12 : 10}>
              <FormDetail step={active} onBack={onBack} onNext={onNext} />
            </Grid>
          </Grid>
        </Form>
      </Formik>
    </>
  );
}

CertificationFormPage.displayName = 'home page component';
